<h1 mat-dialog-title>
  {{title}}
</h1>

<div mat-dialog-content>
  <p>{{message}}</p>
</div>

<div mat-dialog-actions>
  @if (noaction) {
    <button mat-button (click)="onDismiss()">{{noaction}}</button>
  }
  @if (takeaction) {
    <button mat-raised-button color="primary" (click)="onConfirm()" >{{takeaction}}</button>
  }

</div>